module.exports = __webpack_public_path__ + "img/_notes.c795afac.svg";